import { TFunction } from 'i18next';
import { TableColumn, TableStyles } from 'react-data-table-component';
import { NavigateFunction } from 'react-router-dom';
import { WaProduct } from 'src/api/wa/store/models/product/WaProduct';
import { getDetailStatusTranslationKey } from 'src/api/wa/store/models/workplace/OperationStatus';
import LinkButton from 'src/ui/wards/common/button/LinkButton';
import { WaScreensMap } from 'src/ui/wards/router/WardsScreenMap';
import { wardsNavigate } from 'src/ui/wards/router/WardsScreenRegistration';
import { WA_Screen } from 'src/ui/wards/router/WardsScreens';

export const productTableStyle: TableStyles = {
  table: {
    style: {
      backgroundColor: '#f8f8f8',
      borderTop: '2px solid #c026d3',
      padding: '0.625rem',
      borderRadius: '0.25rem',
    },
  },
  headCells: {
    style: {
      backgroundColor: '#f2f3f3',
      borderInline: '1px solid #e3e6e7',
      borderTop: '1px solid #e3e6e7',
      fontWeight: 700,
    },
  },
  rows: {
    style: {
      borderRight: '1px solid #e3e6e7',
      borderBottom: '1px solid #e3e6e7',
      borderLeft: '1px solid #e3e6e7',
    },
  },
};

export const productDataColumns = (
  t: TFunction,
  navigate: NavigateFunction,
  setSelectedProduct: (selectedProduct: WaProduct | null) => void
): TableColumn<WaProduct>[] => {
  return [
    {
      id: 'productNumber',
      name: t('wards.siteDetails.seNumber'),
      selector: (r) => String(r.productNumber),
      cell: (row) => (
        <LinkButton
          title={`${String(row.productNumber)}`}
          onClick={() => {
            setSelectedProduct(row);
            wardsNavigate(navigate, WaScreensMap[WA_Screen.ProductDetails].path);
          }}
          className="text-left"
        />
      ),
      sortable: true,
      grow: 1,
    },
    {
      id: 'unit',
      name: t('wards.siteDetails.unit'),
      selector: (_row) => String(_row.unit),
      sortable: true,
      grow: 1,
    },
    {
      id: 'state',
      name: t('wards.siteDetails.state'),
      selector: (row) => (row.statusId ? t(getDetailStatusTranslationKey(row.statusId)) : ''),
      sortable: true,
      grow: 1,
    },
  ];
};
